import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";

interface Props {
	containerClass?: string;
}

class CardNoData extends Component<Props> {
	render() {
		return (
			<div className={ this.props.containerClass }>
				{ Strings.no_data_available }
			</div>
		);
	}
}

export default CardNoData;
